import * as PIXI from 'pixi.js'

import { WorkSpaceWithBookingNode } from 'modules/space_control/hooks/useWorkSpacesWithBookings'
import { TypeToIcon } from 'modules/space_control/lib/spaceicon'

export const Pin = (
  workSpace: WorkSpaceWithBookingNode,
  options?: {
    onHover?: (workSpaceId: number) => void
    onLeave?: (workSpaceId: number) => void
    onClick?: (workSpaceId: number) => void
  }
) => {
  const pinType = TypeToIcon(workSpace.workSpaceTypeValue)
  if (!pinType) return

  const container = new PIXI.Container()

  const shadow = new PIXI.Graphics()
  shadow.beginFill(0x000000, 0.3)
  shadow.drawRoundedRect(-20, -20, 48, 48, 16)
  shadow.endFill()
  shadow.filters = [new PIXI.filters.BlurFilter(4)]

  container.addChild(shadow)

  const pin = new PIXI.Graphics()
  pin.beginFill(pinType.color)
  pin.drawRoundedRect(-24, -24, 48, 48, 16)
  pin.endFill()

  const svgIconTexture = PIXI.Texture.from(pinType.icon.svg)
  const svgIcon = new PIXI.Sprite(svgIconTexture)
  svgIcon.anchor.set(0.5)
  svgIcon.width = pinType.icon.width
  svgIcon.height = pinType.icon.height
  svgIcon.tint = pinType.icon.color
  pin.addChild(svgIcon)
  container.addChild(pin)

  container.cursor = 'pointer'
  container.interactive = true
  container.on('pointerover', () => {
    pin.tint = pinType.icon.color
    svgIcon.tint = 0xffffff
    container.scale.set(1.1)
    options?.onHover && options.onHover(workSpace.workSpaceId)
  })
  container.on('pointerout', () => {
    pin.tint = '#ffffff'
    svgIcon.tint = pinType.icon.color
    container.scale.set(1)
    options?.onLeave && options.onLeave(workSpace.workSpaceId)
  })
  container.on('pointertap', () => {
    options?.onClick && options.onClick(workSpace.workSpaceId)
  })
  return container
}
